/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/write-input': {
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    data: '<path d="M9.94568 3.10864H2.98793C2.4607 3.10864 1.95506 3.31808 1.58225 3.69089C1.20944 4.0637 1 4.56934 1 5.09657V19.0121C1 19.5393 1.20944 20.0449 1.58225 20.4177C1.95506 20.7906 2.4607 21 2.98793 21H16.9034C17.4307 21 17.9363 20.7906 18.3091 20.4177C18.6819 20.0449 18.8914 19.5393 18.8914 19.0121V12.0543" stroke="#151716" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.4015 1.61757C17.7969 1.22215 18.3332 1 18.8924 1C19.4516 1 19.9879 1.22215 20.3834 1.61757C20.7788 2.01299 21.0009 2.5493 21.0009 3.10852C21.0009 3.66773 20.7788 4.20404 20.3834 4.59946L10.9407 14.0421L6.96484 15.0361L7.95881 11.0602L17.4015 1.61757Z" stroke="#151716" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
